// src/lib/api.ts
import axios from "axios";

const ORIGIN = (import.meta.env.VITE_API_BASE || "").replace(/\/$/, "");

// 같은 오리진이면 "/api", 다른 오리진이면 "https://.../api"
const baseURL = ORIGIN ? `${ORIGIN}/api` : "/api";

const api = axios.create({
  baseURL,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("token");
  if (t) {
    cfg.headers = cfg.headers ?? {};
    cfg.headers.Authorization = `Bearer ${t}`;
  }
  return cfg;
});

export default api;
